var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUvIndexIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_619)",
    filter: "url(#filter0_d_111_619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.375 30.25H15.875C15.4111 30.2494 14.9663 30.0648 14.6383 29.7367C14.3102 29.4087 14.1256 28.9639 14.125 28.5V21.5H15.875V28.5H19.375V21.5H21.125V28.5C21.1244 28.9639 20.9398 29.4087 20.6117 29.7367C20.2837 30.0648 19.8389 30.2494 19.375 30.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.875 21.5H28.3438L26.375 29.4021L24.443 21.5H22.875L25.0625 30.25H27.6875L29.875 21.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.875 5.75H21.125V10.125H22.875V5.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0432 8.7195L26.9756 11.7871L28.2129 13.0244L31.2805 9.95682L30.0432 8.7195Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.25 17.125H29.875V18.875H34.25V17.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 17.125H9.75V18.875H14.125V17.125Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9566 8.71972L12.7192 9.95703L15.7868 13.0246L17.0242 11.7873L13.9566 8.71972Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 18.875H25.5V18C25.5 17.0717 25.1313 16.1815 24.4749 15.5251C23.8185 14.8687 22.9283 14.5 22 14.5C21.0717 14.5 20.1815 14.8687 19.5251 15.5251C18.8687 16.1815 18.5 17.0717 18.5 18V18.875H16.75V18C16.75 16.6076 17.3031 15.2723 18.2877 14.2877C19.2723 13.3031 20.6076 12.75 22 12.75C23.3924 12.75 24.7277 13.3031 25.7123 14.2877C26.6969 15.2723 27.25 16.6076 27.25 18V18.875Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_111_619",
    x: -1.5,
    y: -1.5,
    width: 47,
    height: 47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_111_619"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_111_619",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(8 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUvIndexIcon);
export default __webpack_public_path__ + "static/media/UvIndexIcon.216bdfb17e9e9d679bb575679270f05e.svg";
export { ForwardRef as ReactComponent };